import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AgenteFinanceiroResolver } from "src/app/shared/resolvers/agente-financeiro.resolver";
import { DevolucaoHonraEstadosResolver } from "./devolucao-honra-estados.resolver";
import { DevolucaoHonraCadastroComponent } from "./cadastro/devolucao-honra-cadastro.component";
import { DevolucaoHonraDetalhesComponent } from "./detalhe/devolucao-detalhe.component";
import { DevolucaoHonraPesquisaComponent } from "./pesquisa/devolucao-honra-pesquisa.component";

const routes:Routes = [
    {
        path:'devolucao',
        resolve:{
            agentes: AgenteFinanceiroResolver,
            estados: DevolucaoHonraEstadosResolver,
        },
        children:[
            {
                path:'',
                pathMatch: 'full',
                redirectTo: 'pesquisa',
            },
            {
                path:'pesquisa',
                component:DevolucaoHonraPesquisaComponent
            },
            {
                path:'cadastro',
                component:DevolucaoHonraCadastroComponent
            },
            {
                path:'cadastro/:id',
                component:DevolucaoHonraDetalhesComponent
            }
        ]
    },
];

@NgModule({
    imports:[
        RouterModule.forRoot(routes)
    ],
    exports:[
        RouterModule
    ]
})
export class DevolucaoHonraRoutingModule{

}